import { BottomSheet, Button, Card, Icon, List, Loader, Typography } from '@bharatpe/bharat-ui';
import PageLayout from '@bharatpe/bharat-ui/web/PageLayout';
import React, { useEffect, useState } from 'react';
import { copyToClipboard } from 'utils/nativeSupport';
import autoPayIcon from 'assets/icons/Autopay/autoPayIcon.svg';
import copyIcon from 'assets/icons/Autopay/copyIcon.svg';
import upiListIcon from 'assets/icons/Autopay/upiListIcon.svg';
import transactionHistoryIcon from 'assets/icons/Autopay/transactionHistoryIcon.svg';
import changePinIcon from 'assets/icons/Autopay/changePinIcon.svg';
import forgotPinIcon from 'assets/icons/Autopay/forgotPinIcon.svg';
import unlinkBankIcon from 'assets/icons/Autopay/unlinkBankIcon.svg';
import AlertIcon from 'assets/icons/Autopay/danger.svg';

import history from 'utils/History';
import {
	SET_HOME_MODAL_VISIBILITY,
	SET_ONBOARDING_REDIRECTION_PAGE,
	SET_UPI_STEP,
	useUpiData,
	useUpiStep,
} from 'Slices';
import useUpiStatus from 'Hooks/useUpiStatus';
import { useDispatch } from 'react-redux';
import { isEmpty } from 'utils/Utils';
import Toasty from 'components/atoms/Toasty';
import { ONBOARDING_REDIRECTION_PAGE, UPISteps } from 'utils/CONSTANT';
import { ChangeUPIPin, forgetUPIPin, UPICheckBalance, UPIRemoveBankAccount } from 'utils/nativeUpiHandler';
import accountBalanceIcon from 'assets/icons/Autopay/accountBalanceIcon.svg';
import cardIcon from 'assets/icons/Autopay/cardIcon.svg';
import { CheckCircle, WarningRounded } from '@bharatpe/bharat-ui/web/Icons';
import AppHeader from 'components/atoms/AppHeader';
import { triggerUPIUserDetails, UPIUserDetailsSlice, useUPIUserDetails } from 'Slices/GetUPIUserDetails';
import { registerSlice } from 'store';
import AllModals from 'containers/UPIContainer/Modals';
import UpiPoweredBy from 'components/atoms/UpiPoweredBy';
import WrongPinModal from 'components/organisms/Modals/WrongPinModal';
import { checkPermissions } from 'utils/nativeSupport';
import { sendEvent } from 'utils/Sentry';

registerSlice(UPIUserDetailsSlice);

const ProfileDetails: React.FC = () => {
	const upiStepDetails = useUpiStep();
	const upiStatus = useUpiStatus();
	const { upiStep, upiErr } = upiStepDetails;
	const dispatch = useDispatch();
	const upiData = useUpiData();
	const { va, account, bank_logo } = upiData?.upiProfileDetails?.user_banks[0] || [];
	const [showBankBalanceModal, setShowBankModal] = useState(false);
	const [showSetPinConfirmationModal, setSetPinConfirmationModal] = useState(false);
	const [showPinChangedSuccessfulModal, setPinChangedSuccessfulModal] = useState(false);
	const [showDelinkAccountConfirmationModal, setShowDeinkAccountConfirmationModal] = useState(false);
	const [showDelinkAccountDeniedModal, setShowDeinkAccountDeniedModal] = useState(false);
	const [showWrongPinModal, setShowWrongPinModal] = useState<boolean>(false);
	const [retryFunction, setRetryFunction] = useState<string>('');
	const [loader, setLoader] = useState(false);

	const upiUserData = useUPIUserDetails();

	const setReclaimFlow = async () => {
		if (upiData?.upiProfileDetails?.user_banks[0]) {
			// dispatch(SET_HOME_MODAL_VISIBILITY({ debitCardModal: true }));
			history.push({
				pathname: '/upi/reclaim-bank-list',
			});
		} else {
			Toasty.error('Something went wrong !!!');
		}
	};
	const [amount, setAmount] = useState<string>('');

	useEffect(() => {
		const permissions = checkPermissions();
		permissions.then((data) => {
			if (!data.READ_PHONE_STATE || !data.SEND_SMS) {
				console.log(data.READ_PHONE_STATE, data.SEND_SMS, '----- permissions data here -----');
				dispatch(SET_HOME_MODAL_VISIBILITY({ permissionModal: true }));
			} else {
				if (upiStatus?.loading === false) {
					if (upiErr) {
						Toasty.error(upiErr);
						return;
					}
					if (!isEmpty(upiStep)) {
						dispatch(SET_ONBOARDING_REDIRECTION_PAGE({ source: ONBOARDING_REDIRECTION_PAGE.PROFILE }));
					}
					switch (upiStep) {
						case UPISteps.UPGRADE:
							history.push({ pathname: '/upi/sim-binding' });
							break;
							break;
						case UPISteps.RECLAIM_STATUS:
							setReclaimFlow();
							break;
						case UPISteps.BANK_SCREEN:
							history.push({
								pathname: '/upi/bank-selection',
							});
							break;
					}
				}
			}
		});
	}, [upiStep, upiStatus?.loading]);

	useEffect(() => {
		if ((upiStatus?.upiErr || upiStatus?.upiStep) && isEmpty(upiStepDetails) && !upiStatus?.loading) {
			dispatch(SET_UPI_STEP({ upiStep: upiStatus?.upiStep, upiErr: upiStatus?.upiErr, loading: upiStatus?.loading }));
		}
	}, [dispatch, upiStatus]);

	useEffect(() => {
		if (upiStatus?.loading === false && isEmpty(upiStep)) {
			dispatch(triggerUPIUserDetails());
		}
	}, [dispatch, upiStep, upiStatus]);

	const handleCheckBalanceClick = async () => {
		try {
			const amount = await UPICheckBalance(upiData?.upiProfileDetails?.user_banks[0]);
			if (amount) {
				setAmount(amount as string);
				setShowBankModal(true);
			}
		} catch (error: any) {
			if (error.errorCode == 'ZM') {
				setShowWrongPinModal(true);
				setRetryFunction('balance');
			} else if (error.errorCode == 'Z6') {
				Toasty.error('Exceeded number of pin tries');
			} else if (error?.error === 'USER_ABORTED') {
				//
			} else {
				sendEvent(error);
				Toasty.error('Something went wrong!!');
			}
		}
	};

	const handleChangePinClick = async () => {
		try {
			const isSuccess = await ChangeUPIPin(upiData?.upiProfileDetails?.user_banks[0]);
			if (isSuccess) setPinChangedSuccessfulModal(true);
		} catch (error: any) {
			if (error.errorCode == 'ZM') {
				setShowWrongPinModal(true);
				setRetryFunction('change');
			} else if (error.errorCode == 'Z6') {
				Toasty.error('Exceeded number of pin tries');
			} else if (error?.error === 'USER_ABORTED') {
				//
			} else {
				sendEvent(error);
				Toasty.error('Something went wrong!!');
			}
		}
	};
	const handleForgetPinClick = async () => {
		try {
			const isSuccess = await forgetUPIPin(upiData?.upiProfileDetails?.user_banks[0]);
			if (isSuccess) setPinChangedSuccessfulModal(true);
		} catch (error: any) {
			if (error.errorCode == 'ZM') {
				setShowWrongPinModal(true);
				setRetryFunction('forget');
			} else if (error.errorCode == 'Z6') {
				Toasty.error('Exceeded number of pin tries');
			} else if (error?.error === 'USER_ABORTED') {
				//
			} else {
				sendEvent(error);
				Toasty.error('Something went wrong!!');
			}
		}
	};
	const handleDeleteAccountClick = async () => {
		setShowDeinkAccountConfirmationModal(true);
	};
	const handleShowBalanceModalClose = () => {
		setShowBankModal(false);
	};
	const handleSetPinConfirmationClose = () => {
		setSetPinConfirmationModal(false);
	};
	const handleSetPinConfirmationConfirm = () => {
		handleForgetPinClick();
		setSetPinConfirmationModal(false);
	};
	const handlePinChnageConfirmationClose = () => {
		setPinChangedSuccessfulModal(false);
	};
	const handleDelinkAccountConfirmationClick = async () => {
		setShowDeinkAccountConfirmationModal(false);
		if (upiUserData?.data?.auto_pay_active == true) {
			setShowDeinkAccountDeniedModal(true);
		} else {
			try {
				const isSuccess = await UPIRemoveBankAccount(upiData?.upiProfileDetails?.user_banks[0]);
				if (isSuccess) history.push({ pathname: '/account/delink-success' });
				else Toasty.error('Something went wrong!!');
			} catch (error: any) {
				if (error?.error === 'USER_ABORTED') {
					//
				} else if (error?.errorCode === '712') {
					Toasty.error(error?.error || 'Something went wrong!!');
				} else {
					sendEvent(error);
					Toasty.error('Something went wrong!!');
				}
			}
		}
	};
	const getBankCardStrip = () => {
		if (upiUserData?.data?.auto_pay_active)
			return {
				children: <Typography className="text-center green-text-color">Autopay is active</Typography>,
				variant: 'success',
				showIcon: false,
				className: 'flex-justify-center',
			};
		return undefined;
	};

	const handlePinReset = async () => {
		setShowWrongPinModal(false);
		try {
			const isSuccess = await forgetUPIPin(upiData?.upiProfileDetails?.user_banks[0]);
			if (isSuccess) setPinChangedSuccessfulModal(true);
		} catch (error: any) {
			if (error.errorCode == 'ZM') {
				setShowWrongPinModal(true);
			} else if (error.errorCode == 'Z6') {
				Toasty.error('Exceeded number of pin tries');
			} else if (error?.error === 'USER_ABORTED') {
				//
			} else {
				Toasty.error('Something went wrong!!');
				sendEvent(error);
			}
		}
	};

	const handleRetry = () => {
		setShowWrongPinModal(false);
		switch (retryFunction) {
			case 'balance':
				return handleCheckBalanceClick();
			case 'forget':
				return handleForgetPinClick();
			case 'change':
				handleChangePinClick();
		}
	};

	const profile_list = [
		{
			title: 'UPI ID',
			subtitle: va,
			hideRightArrow: true,
			rightContent: <Icon icon={copyIcon} height={20} />,
			leftIcon: {
				icon: upiListIcon,
				height: '30px',
				width: '30px',
			},
		},
		{
			title: 'Manage Auto Pay',
			leftContentAlignTop: true,
			leftIcon: {
				icon: autoPayIcon,
				height: '30px',
				width: '30px',
			},
		},
		{
			title: 'Transaction History',
			leftContentAlignTop: true,
			leftIcon: {
				icon: transactionHistoryIcon,
				height: '30px',
				width: '30px',
			},
		},
		{
			title: 'Change PIN',
			leftContentAlignTop: true,
			leftIcon: {
				icon: changePinIcon,
				height: '30px',
				width: '30px',
			},
		},
		{
			title: 'Forget UPI PIN',
			leftContentAlignTop: true,
			leftIcon: {
				icon: forgotPinIcon,
				height: '30px',
				width: '30px',
			},
		},
		{
			title: 'Unlink Bank Account',
			leftContentAlignTop: true,
			leftIcon: {
				icon: unlinkBankIcon,
				height: '30px',
				width: '30px',
			},
		},
	];
	const handleOnClick = (val: any, id: number) => {
		if (id == 0) {
			copyToClipboard({ code: va, lable: 'user-vpa', msgText: 'VPA Copied' });
		} else if (id == 1) {
			history.push('/account/manage-auto-pay');
		} else if (id == 2) {
			history.push('/account/transaction-list');
		} else if (id == 3) {
			handleChangePinClick();
		} else if (id == 4) {
			setSetPinConfirmationModal(true);
		} else if (id == 5) {
			handleDeleteAccountClick();
		}
	};
	return upiErr || upiStep == undefined || upiStatus?.loading || loader ? (
		<Loader loading />
	) : (
		<PageLayout className="white-background ">
			<>
				<AppHeader title={'Account Details'} />
				<AllModals setLoader={setLoader} />
				<div className="mx5 mt6">
					<Card strip={getBankCardStrip()} className="p4 flex flex-column">
						<div className="flex flex-row flex-justify flex-center">
							<div>
								<Typography variant="SemiBold300" className="text-left">
									<>
										{upiData?.upiProfileDetails?.user_banks[0]?.['acc-provider-name']} {account}
									</>
								</Typography>
								<Typography variant="Light100" className="text-left grey mt1">
									SAVING ACCOUNT
								</Typography>
							</div>
							<div className="br3 grey-border p2">
								<img src={bank_logo} loading="lazy" height={32} width={32} />
							</div>
						</div>
						<Button variant="outlined" className="width-75 mt4" onClick={() => handleCheckBalanceClick()}>
							CHECK BALANCE
						</Button>
					</Card>
					<List list={profile_list} className={'mt6'} onClick={(val: any, id: number) => handleOnClick(val, id)} />
				</div>
				<div className="upi-powered">
					<UpiPoweredBy />
				</div>
				<BottomSheet
					visible={showBankBalanceModal}
					showCloseButton={true}
					onClose={handleShowBalanceModalClose}
					// heading="Need Permission"
					rounded>
					<div className="p4 flex flex-column">
						<img src={accountBalanceIcon} width={50} height={50} />
						<Typography variant="Regular200" className="grey mt2">
							Your account balance
						</Typography>
						<Typography variant="Bold700" className="mt1 mb4">
							<>₹{amount}</>
						</Typography>
						<Button onClick={handleShowBalanceModalClose} className="mt4">
							Done
						</Button>
					</div>
				</BottomSheet>

				<BottomSheet
					visible={showSetPinConfirmationModal}
					showCloseButton={false}
					// heading="Need Permission"
					rounded>
					<div className="p4 flex flex-column">
						<img src={cardIcon} width={40} height={32} />
						<Typography variant="Bold500" className="mt2">
							Set PIN with Debit card
						</Typography>
						<Typography variant="Regular200" className="grey mt1 mb4">
							Kindly proceed only if you have the same mobile number ({upiUserData?.data?.mobile}) registered with Debit
							card. Keep you debit card with you to verify 16 digit number
						</Typography>
						<div className="flex flex-row mt4">
							<Button onClick={handleSetPinConfirmationClose} variant="outlined" className="mr2 width-50">
								BACK
							</Button>
							<Button onClick={handleSetPinConfirmationConfirm} className="width-50">
								CONTINUE
							</Button>
						</div>
					</div>
				</BottomSheet>
				<BottomSheet
					visible={showPinChangedSuccessfulModal}
					showCloseButton={false}
					// heading="Need Permission"
					rounded>
					<div className="p4 flex flex-column">
						<Icon icon={CheckCircle} className="mr2 success-logo" width={40} height={40} />
						<Typography variant="Bold500" className="mt2">
							PIN Successfully Changed
						</Typography>
						<Typography variant="Regular200" className="grey mt1 mb4">
							You have successfully updated your UPI PIN for{' '}
							{upiData?.upiProfileDetails?.user_banks[0]?.['acc-provider-name']} account {account}
						</Typography>
						<Button onClick={handlePinChnageConfirmationClose} className="mt4">
							Done
						</Button>
					</div>
				</BottomSheet>
				<BottomSheet
					visible={showDelinkAccountConfirmationModal}
					showCloseButton={false}
					// heading="Need Permission"
					rounded>
					<div className="p4 flex flex-column">
						<Icon icon={WarningRounded} className="mr2 failed-logo" width={40} height={40} />
						<Typography variant="Bold500" className="mt2">
							Are you sure?
						</Typography>
						<Typography variant="Regular200" className="grey mt1 mb4">
							If you unlink your account, you will no longer be able to use it for payments on BharatPe. Do you still
							want to proceed with unlinking your bank account?
						</Typography>
						<div className="flex flex-row mt4">
							<Button
								onClick={handleDelinkAccountConfirmationClick}
								color="danger"
								variant="outlined"
								className="mr2 width-50">
								UNLINK
							</Button>

							<Button onClick={() => setShowDeinkAccountConfirmationModal(false)} className="width-50">
								CANCEL
							</Button>
						</div>
					</div>
				</BottomSheet>
				<BottomSheet visible={showDelinkAccountDeniedModal} showCloseButton={false} rounded>
					<div className="p4 flex flex-column">
						<Icon icon={WarningRounded} className="mr2 failed-logo" width={40} height={40} />
						<Typography variant="Bold500" className="mt2">
							Not Allowed!
						</Typography>
						<Typography variant="Regular200" className="grey mt1 mb4">
							You cannot delete this bank account because it is linked to Autopay payments for an ongoing loan.
						</Typography>
						<div className="flex flex-row mt4">
							<Button onClick={() => setShowDeinkAccountDeniedModal(false)} className="width-100">
								OKAY
							</Button>
						</div>
					</div>
				</BottomSheet>
				{showWrongPinModal && (
					<WrongPinModal
						handleClickPrimary={handlePinReset}
						handleClickSecondary={handleRetry}
						handleModalClose={() => setShowWrongPinModal(false)}
						title={'Wrong UPI PIN entered'}
						description={
							'Please use the correct PIN and try again. your bank will temporarily block UPI payments, if you enter the wrong PIN too many times.'
						}
						primaryButtonName={'Reset PIN'}
						secondaryButtonName={'Retry'}
						icon={AlertIcon}
						type={'info'}
					/>
				)}
			</>
		</PageLayout>
	);
};

export default ProfileDetails;
